import React from 'react'
import { Navigate, useParams } from 'react-router'
import { AppRoutes } from '@core/AppRoutes'
import { ProfileFollowList } from '@core/Areas/FollowMe/Components/ProfileFollowList'

export const ProfileFollowListPage = () => {
  const { profileId } = useParams<{ profileId: string }>()

  if (!profileId) {
    return <Navigate to={AppRoutes.BetLoop} />
  }
  return <ProfileFollowList profileId={profileId} />
}
